/*
 * @Description: 
 * @version: 1.0.0
 * @Author: Joy.xushaojia
 * @Date: 2023-12-25 11:41:04
 * @LastEditors: huangzeshen
 * @LastEditTime: 2024-06-20 23:17:31
 */
import { lazy } from "react"

const userModule: AsyncRoute.Routes[] = [
  {
    path: "/",
    index: true,
    // skeleton: <></>,
    component: lazy(() => import(/* webpackChunkName: "user" */ "../../pages/openAccount/components/bindInfo/index")),
  },
  // 开户
  {
    path: "/openAccount",
    index: true,
    // skeleton: <></>,
    component: lazy(() => import(/* webpackChunkName: "user" */ "../../pages/openAccount/components/bindInfo/index")),
  },
  {
    path: "/openAccount/bindInfo",
    index: true,
    // skeleton: <></>,
    component: lazy(() => import(/* webpackChunkName: "user" */ "../../pages/openAccount/components/bindInfo/index")),
  },
  {
    path: "/openAccount/chooseCounty",
    index: true,
    // skeleton: <></>,
    component: lazy(() => import(/* webpackChunkName: "user" */ "../../pages/openAccount/components/chooseCounty/index")),
  },
  {
    path: "/openAccount/chooseType",
    index: true,
    // skeleton: <></>,
    component: lazy(() => import(/* webpackChunkName: "user" */ "../../pages/openAccount/components/chooseType/index")),
  },
  {
    path: "/openAccount/updateInfo",
    index: true,
    // skeleton: <></>,
    component: lazy(() => import(/* webpackChunkName: "user" */ "../../pages/openAccount/components/updateInfo/index")),
  },
  {
    path: "/openAccount/faceCheck",
    index: true,
    // skeleton: <></>,
    component: lazy(() => import(/* webpackChunkName: "user" */ "../../pages/openAccount/components/faceCheck/index")),
  },
  {
    path: "/openAccount/bankCheck",
    index: true,
    // skeleton: <></>,
    component: lazy(() => import(/* webpackChunkName: "user" */ "../../pages/openAccount/components/bankCheck/index")),
  },
  {
    path: "/openAccount/selectMarket",
    index: true,
    // skeleton: <></>,
    component: lazy(() => import(/* webpackChunkName: "user" */ "../../pages/openAccount/components/selectMarket/index")),
  },
  {
    path: "/openAccount/questionnaire",
    index: true,
    // skeleton: <></>,
    component: lazy(() => import(/* webpackChunkName: "user" */ "../../pages/openAccount/components/questionnaire/index")),
  },
  {
    path: "/openAccount/riskDisclosure",
    index: true,
    // skeleton: <></>,
    component: lazy(() => import(/* webpackChunkName: "user" */ "../../pages/openAccount/components/riskDisclosure/index")),
  },
  {
    path: "/openAccount/agreement",
    index: true,
    // skeleton: <></>,
    component: lazy(() => import(/* webpackChunkName: "user" */ "../../pages/openAccount/components/agreement/index")),
  },
  {
    path: "/openAccount/signature",
    index: true,
    // skeleton: <></>,
    component: lazy(() => import(/* webpackChunkName: "user" */ "../../pages/openAccount/components/signature/index")),
  },
  {
    path: "/openAccount/transactionPassword",
    index: true,
    // skeleton: <></>,
    component: lazy(() => import(/* webpackChunkName: "user" */ "../../pages/openAccount/components/transactionPassword/index")),
  },
  {
    path: "/openAccount/openEnd",
    index: true,
    // skeleton: <></>,
    component: lazy(() => import(/* webpackChunkName: "user" */ "../../pages/openAccount/components/openEnd/index")),
  },

  {
    path: "/openAccount/taxes",
    index: true,
    // skeleton: <></>,
    component: lazy(() => import(/* webpackChunkName: "user" */ "../../pages/openAccount/components/taxes/index")),
  },
  // end of 开户

  // 孖展更新
  {
    path: "/margin/first",
    index: true,
    // skeleton: <></>,
    component: lazy(() => import(/* webpackChunkName: "user" */ "../../pages/Margin/first")),
  },
  {
    path: "/margin/second",
    index: true,
    // skeleton: <></>,
    component: lazy(() => import(/* webpackChunkName: "user" */ "../../pages/Margin/second")),
  },
  {
    path: "/margin/third",
    index: true,
    // skeleton: <></>,
    component: lazy(() => import(/* webpackChunkName: "user" */ "../../pages/Margin/third")),
  },
  // end of 孖展更新

  // 帮助中心详情
  {
    path: "/help/detail/:id",
    index: true,
    // skeleton: <></>,
    component: lazy(() => import(/* webpackChunkName: "user" */ "../../pages/help/detail")),
  },
  // 新闻详情
  {
    path: "/News/detail",
    index: true,
    // skeleton: <></>,
    component: lazy(() => import(/* webpackChunkName: "user" */ "../../pages/News/detail")),
  },

];
export default userModule;